import React, {Component} from "react";
import BilateralControlPanelView from "./BilateralControlPanelView";
import {
    formattedNumber,
    formattedPremium,
    price,
    rate
} from "../../../utils/formatters/Numbers";
import {Growl} from "primereact/growl";
import {
    BILATERAL_CONTROL_PANEL_DETAIL_LOAN_ROUTE,
    BILATERAL_CONTROL_PANEL_ROUTE
} from "../../../utils/constants/RoutesConstants";
import {BORROWER, LENDER} from "../../../utils/constants/Constants";
import ContextMenu from "../../../components/contextMenu";
import PropTypes from "prop-types";
import {BilateralControlPanelService} from "../../../service/bilateral/controlPanel/BilateralControlPanelService";
import {BilateralCatalogService} from "../../../service/bilateral/catalog/BilateralCatalogService";
import {isEmptyObject} from "../../../utils/validator/Objects";
import {formatYYYMMDD} from "../../../utils/formatters/Date";
import {BilateralReportService} from "../../../service/bilateral/report/BilateralReportService";


export default class BilateralControlPanelContainer extends Component {
    refreshTimeoutId;

    constructor(props) {
        super(props);
        this.controlPanelTable = React.createRef();

        this.bilateralControlPanelService = new BilateralControlPanelService();
        this.bilateralCatalogService = new BilateralCatalogService();
        this.bilateralReportService = new BilateralReportService();
        this.loading = this.loading.bind(this);
        this.loadingControlPanel = this.loadingControlPanel.bind(this);
        this.controlPanelTemplate = this.controlPanelTemplate.bind(this);
        this.getControlPanelLoanList = this.getControlPanelLoanList.bind(this);
        this.selectRowControlPanel = this.selectRowControlPanel.bind(this);
        this.onRowDoubleClickControlPanel = this.onRowDoubleClickControlPanel.bind(this);
        this.saveFilters = this.saveFilters.bind(this);
        this.boldAndColor = this.boldAndColor.bind(this);
        this.boldAndColorTextTemplate = this.boldAndColorTextTemplate.bind(this);
        this.boldAndColorAmountTemplate = this.boldAndColorAmountTemplate.bind(this);
        this.boldAndColorPriceTemplate = this.boldAndColorPriceTemplate.bind(this);
        this.boldAndColorNumberTemplate = this.boldAndColorNumberTemplate.bind(this);
        this.boldAndColorRateTemplate = this.boldAndColorRateTemplate.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        this.startTimeRefreshControlPanel = this.startTimeRefreshControlPanel.bind(this);
        this.stopTimeRefreshControlPanel = this.stopTimeRefreshControlPanel.bind(this);
        this.getCatalogFilters = this.getCatalogFilters.bind(this)
        this.getFilterParams = this.getFilterParams.bind(this);
        this.getReport = this.getReport.bind(this);

        this.today = new Date();
        this.state = {
            isLoading: false,
            isLoadingControlPanel: false,
            isAdminUser: localStorage.getItem("institution") === "Interno",
            filters: {
                loanId:  '',
                lenderObj: [],
                borrowerObj: [],
                flowObj: [],
                concertDate: '',
            },
            catLender: [],
            catBorrower: [],
            catFlow:[],
            loanControlPanelList: [],
            selectedControlPanel: '',
            today: this.today,

            bilateralExportOptions: [
                {
                    label: "Día", action: () => {
                        this.getReport("daily");
                    }
                },
                {
                    label: "Vigentes", action: () => {
                        this.getReport("current");
                    }
                },
                {
                    label: "Tablero", action: () => {
                        this.getReport("controlPanel", this.getFilterParams());
                    }
                },
            ],
            disabledSearchButton: true,
        };
        this.getControlPanelLoanList();
    };

    startTimeRefreshControlPanel() {
        this.refreshTimeoutId = setInterval(this.getControlPanelLoanList, 10000);
    }

    stopTimeRefreshControlPanel() {
        clearInterval(this.refreshTimeoutId);
    }

    loading(isLoading) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: isLoading
            });
        }
    }

    loadingControlPanel(isLoading) {
        if (this.state !== undefined) {
            this.setState({
                isLoadingControlPanel: isLoading
            });
        }
    }

    componentDidMount() {
        let message = this.props.location.message ? this.props.location.message : null;
        if (message !== null && message.severity) {
            this.growl.show({
                severity: message.severity ? message.severity : '',
                summary: message.summary ? message.summary : '',
                detail: message.detail ? message.detail : '', message
            });
        }
        this.getCatalogFilters();
        this.startTimeRefreshControlPanel();
    }

    componentWillUnmount() {
        this.stopTimeRefreshControlPanel();
    }


    saveFilters(event) {
        const {name, value} = event.target;
        this.setState((prevState) => {
            const filtersAux = { ...prevState.filters };
            filtersAux[name] = value;
            return {
                filters: filtersAux,
            };
        });
    }

    selectRowControlPanel(event) {
        this.setState({
            selectedControlPanel: event.value,
        });
    }

    onRowDoubleClickControlPanel(event) {
        let continueAction = this.getContinueAction(event.data.actions)
        if(isEmptyObject(continueAction)) {
            this.handleControlPanelContextMenu(BILATERAL_CONTROL_PANEL_DETAIL_LOAN_ROUTE);
        } else {
            this.handleControlPanelContextMenu(continueAction.screenRoute);
        }
    }

    handleControlPanelContextMenu(url) {
        if (url === '' || url === undefined) {
            alert("Funcionalidad en proceso.");
        } else {
            this.props.history.push({
                pathname: url,
                state: {
                    isAdmin: false,
                    returnPath: BILATERAL_CONTROL_PANEL_ROUTE,
                    selectedLoanControlPanel: this.state.selectedControlPanel,
                },
            });
        }
    }

    controlPanelTemplate(rowData) {
        let actionList = rowData.actions;
        let optionsMenuControlPanel = [];
        for (const action of actionList) {
            optionsMenuControlPanel.push({
                label: action.value,
                action: () => this.handleControlPanelContextMenu(action.screenRoute),
                isBold: action.value === "Continuar",
            })
        }
        return (
            <ContextMenu menuOptions={optionsMenuControlPanel}/>
        );
    }

    boldAndColor(rowData, value, column) {
        if(isEmptyObject(this.getContinueAction(rowData.actions))) {
            return <span style={{color: 'black'}}>{value}</span>;
        } else {
            return <span style={{fontWeight: 'bold', color: 'black'}}>{value}</span>;
        }

    }

    getContinueAction(actions) {
        for (const action of actions) {
            if(action.value === "Continuar"){
                return action;
            }
        }
        return {};
    }

    boldAndColorTextTemplate(rowData, column) {
        return this.boldAndColor(rowData, rowData[column.field], column.field);
    }

    boldAndColorAmountTemplate(rowData, column) {
        return this.boldAndColor(rowData, formattedPremium(rowData[column.field], "right"));
    }

    boldAndColorPriceTemplate(rowData, column) {
        return this.boldAndColor(rowData, price(rowData[column.field], "right"));
    }

    boldAndColorNumberTemplate(rowData, column) {
        return this.boldAndColor(rowData, formattedNumber(rowData[column.field], "right"));
    }

    boldAndColorRateTemplate(rowData, column) {
        return this.boldAndColor(rowData, rate(rowData[column.field], "right"));
    }


    getControlPanelLoanList() {
        if (this.state !== undefined && !this.state.isLoadingControlPanel) {
            this.loading(true);
            this.loadingControlPanel(true);
            this.bilateralControlPanelService.getControlPanelLoanList(this.getFilterParams())
                .then( res => {
                if (this.validResponse(res)){
                    this.setState({
                        loanControlPanelList: this.reformatResponseList(res.data),
                    })
                }
                this.loading(false);
                this.loadingControlPanel(false);
            });
        }
    }

    getFilterParams() {
        let controlPanelFilters = this.state.filters;
        return {
            id: this.getValidId(controlPanelFilters.loanId),
            lenderId: this.getValidId(controlPanelFilters.lenderObj.id ),
            borrowerId: this.getValidId(controlPanelFilters.borrowerObj.id),
            flow: controlPanelFilters.flowObj.name ?? '',
            valueDate: this.getValidDate(controlPanelFilters.concertDate)
        }
    }

    getValidId(idToValidate){
        return (idToValidate === undefined || idToValidate==='') ? 0 : idToValidate;
    }
    getValidDate(dateToValidate) {
        return dateToValidate === undefined || dateToValidate === '' ? '' : formatYYYMMDD(dateToValidate);
    }

    reformatResponseList(responseList){
        return responseList.map((loan) => (
            {
                id: loan.loanResponse.id,
                flow: loan.loanResponse.flow,
                status: loan.loanResponse.status,
                instrument: loan.loanResponse.instrument,
                title: loan.loanResponse.title,
                price: loan.loanResponse.price,
                amount: loan.loanResponse.amount,
                rate: loan.loanResponse.rate,
                premium: loan.loanResponse.premium,
                lender: loan.loanResponse.lender,
                borrower: loan.loanResponse.borrower,
                term: loan.loanResponse.term,
                lenderAccount: loan.loanResponse.lenderAccount,
                actions: loan.actions
            }
        ));
    }

    getCatalogFilters() {
        this.loading(true);
        this.bilateralCatalogService.getCatalogInstitutions(LENDER).then(
            res => {
                if (this.validResponse(res)){
                    this.setState({
                        catLender: res.data,
                    });
                }
                this.bilateralCatalogService.getCatalogInstitutions(BORROWER).then(
                    res => {
                        if (this.validResponse(res)){
                            this.setState({
                                catBorrower: res.data,
                            });
                        }
                        this.bilateralCatalogService.getCatalogFlow().then(
                            res => {
                                if (this.validResponse(res)){
                                    this.setState({
                                        catFlow: res.data,
                                    });
                                }
                            }
                        );
                    }
                );
                this.loading(false);
            }
        );
    }

    validResponse (res){
        if (res.status!== 200){
            this.growl.show({severity: 'error', summary: 'Error.',
                detail: res.message  + ' ' + res.debugMessage});
            return false;
        }
        return true;
    }

    clearFilters() {
        let filtersAux = {
            loanId:  '',
            lenderObj: [],
            borrowerObj: [],
            flowObj: [],
            concertDate: '',
        }
        this.setState({
            filters: filtersAux
        });
    }

    getReport(type, params) {
        this.loading(true);
        this.bilateralReportService.getControlPanelReport(type, params)
            .then(response => {
                this.loading(false);
            });
    }

    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;


        return <BilateralControlPanelView
            messagesGrowl={messagesGrowl}
            loanControlPanelList={this.state.loanControlPanelList}
            filters={this.state.filters}
            isLoading={this.state.isLoading}
            selectedControlPanel={this.state.selectedControlPanel}
            controlPanelTable={this.controlPanelTable}
            bilateralExportOptions={this.state.bilateralExportOptions}
            today={this.state.today}
            concertDate={this.state.concertDate}
            isAdminUser={this.state.isAdminUser}
            catLender={this.state.catLender}
            catBorrower={this.state.catBorrower}
            catFlow={this.state.catFlow}
            saveFilters={this.saveFilters}
            selectRowControlPanel={this.selectRowControlPanel}
            controlPanelTemplate={this.controlPanelTemplate}
            getControlPanelLoanList={this.getControlPanelLoanList}
            onRowDoubleClickControlPanel={this.onRowDoubleClickControlPanel}
            boldAndColorTextTemplate={this.boldAndColorTextTemplate}
            boldAndColorAmountTemplate={this.boldAndColorAmountTemplate}
            boldAndColorPriceTemplate={this.boldAndColorPriceTemplate}
            boldAndColorNumberTemplate={this.boldAndColorNumberTemplate}
            boldAndColorRateTemplate={this.boldAndColorRateTemplate}
            clearFilters={this.clearFilters}

        />
    }
};

BilateralControlPanelContainer.propTypes = {
    location: PropTypes.object,
    history: PropTypes.object,
};